import { mapGetters } from 'vuex';
import mvtDialog from '@/common/components/mvtdialog/mvt-dialog.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'caPrivacy',
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtDialog,
        mvtHeader,
        mvtFooter,
    },
    data() {
        return {
            categories: [
                {
                    text: "<span>Name, contact information and other identifiers:</span> identifiers such as a real name, alias, address, unique personal identifier, online identifier, Internet Protocol (IP) address, email address, account name, social security number, driver's license number, passport number, or other similar identifiers.",
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: "<span>Customer records:</span> paper and electronic customer records containing personal information, including without limitation, name, signature, physical characteristics or description, address, telephone number, education, current employment, employment history, social security number, passport number, driver's license or state identification card number, insurance policy number, bank account number, credit card number, debit card number, or any other financial or payment information, medical information, or health insurance information.",
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Protected classifications:</span> characteristics of protected classifications under applicable state or federal law such as race, color, sex, age, religion, national origin, disability, citizenship status, and genetic information.',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Commercial Information:</span> including records of real property, products or services purchased, obtained, or considered, or other purchasing or use histories or tendencies.',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: "<span>Usage data:</span> internet or other electronic network activity Information including without limitation browsing history, search history, and information regarding a consumer's interaction with an Internet website, application, or advertisement.",
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Geolocation data:</span> precise geographic location information about a particular individual or device.',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Audio, Video and other Electronic Data: </span> audio, electronic, visual, thermal, olfactory, or similar information such as, CCTV footage, photographs, and call recordings.',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Employment history: </span> professional or employment-related information',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: '<span>Education information:</span> education information that is not publicly available personally identifiable information as defined in the federal Family Educational Rights and Privacy Act (20 U.S.C. section 1232g, 34 C.F.R. Part 99).',
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
                {
                    text: "<span>Profiles and inferences:</span> Inferences drawn from any of the information identified above to create a profile reflecting a resident's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, or aptitudes.",
                    isCollect: 'Yes',
                    isDisclose: 'Yes',
                },
            ],
        };
    },

    computed: {
        ...mapGetters('glb', ['glb']),
    },
};
